import { Header } from 'components/molecules';
import { EditUserTemplate } from 'components/templates';
import { withAuth } from 'HOCs';

const breadcrumbs = [{ label: 'Administración' }];

const EditBotPage = () => {
  return (
    <>
      <Header
        title="Usuarios"
        subtitle="Edita un usuario"
        breadCrumbsProps={{ breadcrumbs: breadcrumbs }}
      />
      <EditUserTemplate />
    </>
  );
};

export default withAuth(EditBotPage, undefined, 'mayasoft');
